'use client';

import {socialProofContent} from '@/lib/landing/content';
import {FadeIn, SectionContainer} from './shared';

export function SocialProofSection() {
  const {title, trustSignals, stats} = socialProofContent;

  return (
    <section aria-labelledby="social-proof-heading" className="py-10 lg:py-12 bg-kobra-bg border-y border-kobra-border relative">
      <SectionContainer className="text-center space-y-8">
        <FadeIn>
          <h2
            id="social-proof-heading"
            className="text-sm sm:text-base font-semibold text-kobra-text-muted uppercase tracking-wider max-w-2xl mx-auto"
          >
            {title}
          </h2>
        </FadeIn>

        <FadeIn delay={0.1}>
          <ul
            className="flex flex-wrap items-center justify-center gap-x-2 gap-y-3 text-sm sm:text-base text-kobra-text-dark font-medium"
            aria-label="Capacidades de confianza"
          >
            {trustSignals.map((signal, index) => (
              <li key={signal} className="flex items-center gap-2">
                {index > 0 ? (
                  <span aria-hidden="true" className="text-kobra-text-muted/50 select-none">
                    ·
                  </span>
                ) : null}
                <span>{signal}</span>
              </li>
            ))}
          </ul>
        </FadeIn>

        {stats.length > 0 ? (
          <ul className="flex flex-wrap items-center justify-center gap-8 lg:gap-12 pt-2">
            {stats.map((stat, index) => (
              <FadeIn key={stat.label} delay={index * 0.1}>
                <li className="text-center">
                  <p className="text-2xl sm:text-3xl font-bold text-kobra-text-dark">{stat.value}</p>
                  <p className="text-sm text-kobra-text-muted mt-1">{stat.label}</p>
                </li>
              </FadeIn>
            ))}
          </ul>
        ) : null}
      </SectionContainer>
    </section>
  );
}
